import { render, staticRenderFns } from "./SBUserData.html?vue&type=template&id=610a8504&scoped=true&"
import script from "./SBUserData.ts?vue&type=script&lang=ts&"
export * from "./SBUserData.ts?vue&type=script&lang=ts&"
import style0 from "./SBUserData.css?vue&type=style&index=0&id=610a8504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a8504",
  null
  
)

export default component.exports